import React from "react";
import SdRsvpPage from "../sd/SdRsvpPage";

export const HENDOS_EVENT = Object.freeze({
  key: "hendos-salute-social-2026",
  slug: "salute-social-hendos-2026",
  path: "/events/salute-social-hendos-2026",
  event_id: "socal26-salute-social-temecula-2026-10-22",
  slotLabel: "General Admission",
  title: "Salute & Social at Hendo's Barrel House",
  subtitle: "Connect with the Road Home Program community in Temecula.",
  dateLabel: "Thursday, October 22, 2026",
  timeLabel: "6:00–8:00 PM PT",
  venueName: "Hendo's Barrel House",
  addressLines: ["27901 Jefferson Avenue", "Temecula, CA 92590"],
  webBanner:
    "https://jpipyazhmdhsixbirvpx.supabase.co/storage/v1/object/public/event-page-images/media-library/1790045323649-hendos-banner.png",
  description:
    "Join us for an evening of connection and community with complimentary light bites.",
  mode: "multi",
  ticketing: "hosted",
  hostedTicketGuestFields: "name-email",
  limits: { maxAttendees: 6, capacityTotal: 100 },
  mailingListInterests: [
    "Salute & Social updates",
    "Southern California event updates",
  ],
  calendar: {
    startUtc: "2026-10-23T01:00:00Z",
    endUtc: "2026-10-23T03:00:00Z",
    timezone: "America/Los_Angeles",
    location: "Hendo's Barrel House, 27901 Jefferson Avenue, Temecula, CA 92590",
    description:
      "Salute & Social hosted by the Road Home Program. Complimentary light bites.",
    publicEventUrl:
      "https://www.roadhome.io/events/salute-social-hendos-2026",
  },
});

export default function HendosEventPage() {
  return (
    <SdRsvpPage
      event={HENDOS_EVENT}
      topLabel="Road Home Program"
      showTeamSection={false}
      unavailableLabel="RSVP unavailable"
      unavailableMessage="Registration is not available right now. Please check back soon."
    />
  );
}
